(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quote-cart-request"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.quote-request__trigger');
    if (trigger) {
      document.getElementById(trigger.getAttribute('aria-controls'))?.showModal();
      return;
    }
    const close = event.target.closest('.quote-request__close');
    if (close) close.closest('dialog')?.close();
  });
  document.addEventListener('click', (event) => {
    if (event.target.matches('.quote-request__dialog')) event.target.close();
  });
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-quote-profession]');
    if (!select) return;
    const wrapper = select.closest('.quote-request__panel')?.querySelector('[data-other-profession]');
    const input = wrapper?.querySelector('input');
    const isOther = select.selectedOptions[0]?.hasAttribute('data-other-option');
    if (wrapper) wrapper.hidden = !isOther;
    if (input) {
      input.disabled = !isOther;
      input.required = isOther;
      if (isOther) input.focus();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quote-product-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.quote-guide__trigger');
    if (trigger) {
      document.getElementById(trigger.getAttribute('aria-controls'))?.showModal();
      return;
    }
    const close = event.target.closest('.quote-guide__close, .quote-guide__action');
    if (close) close.closest('dialog')?.close();
  });
  document.addEventListener('click', (event) => {
    if (event.target.matches('.quote-guide__dialog')) event.target.close();
  });
  } catch(e) { console.error(e); }
})();

})();
